var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"book",class:{ startBtn: _vm.bgc !== '#242B2A' },style:({ 'background-color': _vm.bgc })},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }